import { z } from 'zod';
import { createSessionCookie } from "./create-session-cookie";
import { createSessionUserCookie } from "./create-session-user-cookie";
import { postData } from "../api/fetch";

export async function submitLoginForm(appUser, prevState, formData) {

    const LoginFormSchema = z.object({
        email: z
            .email({ message: "Ongeldig e-mailadres." })
            .min(1, { message: "Vul een e-mailadres in." })
            .max(100, { message: "E-mailadres is te lang." }),
        password: z
            .string()
            .min(1, { message: "Vul je wachtwoord in." })
            .max(100, { message: "Wachtwoord is te lang." }),
    });

    const rawData = {
        email: formData.get("email"),
        password: formData.get("password"),
    };

    const validatedFields = LoginFormSchema.safeParse(rawData);

    if (!validatedFields.success) {
        return {
            ok: false,
            errors: validatedFields.error.flatten().fieldErrors
        }
    }

    try {
        const data = await postData('website/login', Object.fromEntries(formData), { appUser: appUser });

        if (!data || data.error || !data.accessToken || !data.appUser) return {
            ok: false,
            message: "Er ging iets mis bij het inloggen."
        }

        // Session cookies
        const setCookie = await createSessionCookie(data.accessToken);
        const setUserCookie = await createSessionUserCookie(data.appUser);
        if (!setCookie.ok || !setUserCookie.ok) {
            return {
                ok: false,
                message: "Er ging iets mis bij het inloggen."
            }
        }

        return {
            ok: true
        }
    } catch (err) {
        return {
            ok: false,
            message: "Er ging iets mis bij het inloggen."
        }
    }
}